module.exports = __webpack_public_path__ + "img/EducationDivider.cf0a19b0.svg";